import hashChange from '../behaviors/hash-change'
// eslint-disable-next-line no-restricted-imports
import {on} from 'delegated-events'

// TODO Replace with <tab-container> custom element.
function selectTab(tabTarget: HTMLAnchorElement) {
  const container = tabTarget.closest<HTMLElement>('.js-org-insights-hero-container')!

  // unselect all tabs except the one being activated
  for (const tab of container.querySelectorAll('[role=tab]')) {
    tab.setAttribute('aria-selected', (tab === tabTarget).toString())
  }

  // hide all tabpanels except the one being activated
  for (const tabPanel of container.querySelectorAll<HTMLElement>('[role=tabpanel]')) {
    tabPanel.hidden = tabTarget.id !== tabPanel.getAttribute('aria-labelledby')
  }

  // force the timespan links to preserve the prs/issues fragment
  for (const link of document.querySelectorAll<HTMLAnchorElement>('.js-org-insights-period-selector-link')) {
    link.hash = tabTarget.hash
  }
}

on('click', '.js-org-insights-hero-container [role=tab]', ({currentTarget}) => {
  if (currentTarget instanceof HTMLAnchorElement) selectTab(currentTarget)
})

// TODO Replace this JS with query string parameter for active tab.
hashChange(() => {
  const container = document.querySelector('.js-org-insights-hero-container')
  if (!container) return

  const tab = container.querySelector(`[href='${document.location.hash || '#insights-prs'}']`)
  if (tab instanceof HTMLAnchorElement) {
    selectTab(tab)
  }
})
